import { gql } from '@apollo/client'

export const RESTORE_CAMPAIGN_TO_SKETCH = gql`
  mutation restoreCampaignToSketch($id: ID!) {
    restoreCampaignToSketch(input: { id: $id }) {
      campaign {
        id
        status
      }
      success
      errors
    }
  }
`
